var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',{staticClass:"text-center display-1 py-6"},[_vm._v("About Lowkey Hubadera")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }